import { CheckBox, CheckBoxProps } from '@sharedUi/ui-kit/CheckBox';
import { MyLink } from '@app/shared';
import React, { forwardRef } from 'react';
import classNames from 'classnames';

import styles from './CustomCheckBox.module.scss';

interface CheckBoxAgreeProps extends Omit<CheckBoxProps, 'children'> {
  reg?: any;
}

export const CheckBoxAgree = forwardRef<HTMLInputElement, CheckBoxAgreeProps>(({ id, className, ...props }, ref): JSX.Element => {
  return (
    <CheckBox id={id} className={classNames(styles.Wrapper, className)} data-testid="checkbox-personal-data" ref={ref} {...props}>
      <div className={styles.Text}>Даю согласие на обработку&nbsp;</div>
      <MyLink target="_blank" href="/static-page/soglasie/" rel="noreferrer" data-testid="soglashenie-na-obrabotku-personalnyih-dannyih">
        персональных данных
      </MyLink>
    </CheckBox>
  );
});

CheckBoxAgree.displayName = 'CheckBoxAgree';
